module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/defaultMenu.870a2959.svg";